import type { Graph3DVector3 } from '../core/graph.types';

export function toCanvasPosition(position: Graph3DVector3): [number, number, number] {
  return [position.x, position.y, position.z];
}

export function normalizeDepth(depth: number | undefined, zGap: number): number {
  return (depth ?? 0) * zGap;
}
